// Only allow the following steps to be restored from localStorage
import { PostJobSteps } from 'Douleutaras/views/job/post-job/hooks/post-job';

export const STEPS_ALLOWED_TO_RESTORE_FROM_STORAGE = [
  PostJobSteps.QUESTIONS_STEP,
  PostJobSteps.LOCATION_STEP
];
